import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeTable,
  mapDdeTable,
  type ServerDdeTableResponse,
} from './ddeTableTypes';

type UpdateDdeTableRequest = {
  name: string;
  tableId: string;
};

export const updateDdeTable = async ({
  name,
  tableId,
}: UpdateDdeTableRequest): Promise<DdeTable> => {
  const response = await sylvanus.patch<ServerDdeTableResponse>(
    `/dde/table/${tableId}`,
    { name },
  );

  return mapDdeTable(response);
};
